import { Avatar, Box, Flex, Typography } from "../../../ppui";


export const AttendanceHeaders=[
   {
    key: "emp_name",
    label: "Employee Name",
    isClickable: true,
    isShortable: false,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (row) => <>

      <Flex alignItems="center" >
        <Avatar
          className={"avatarHover"}
          size="sm"
          color="secondary"
          initials={`${row?.emp_name?.split(" ")?.[0]?.[0]?.toUpperCase()}${row?.emp_name?.split(" ")?.[1]?.[0]?.toUpperCase()}`} // Join the initials with a dot
          sx={{ marginInlineEnd: "0.625rem" }}
        />
        <Box >
          {row?.emp_name?.toUpperCase()}
          <Typography
            color={"default"}
            colorVariant={"light"}
            variant={"body2"}
            mb={"0"}
          >
            #{row?.employee_id}
          </Typography>
        </Box>
      </Flex>
    </>,
  },
  {
    key: "dept_name",
    label: "Department Name",
    // isClickable: true,
    isShortable: false,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (row) => row?.dept_name,
  },
  {
    key: "total_hour",
    label: "Total Hours",
    // isClickable: true,
    isShortable: false,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (row) => row?.total_hour,
  },
  {
    key: "total_minute",
    label: "Total Minutes",
    // isClickable: true,
    isShortable: false,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (row) => row?.total_minute,
  },

]